import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { injectIntl } from 'react-intl';

class FilterSearchBox extends Component {

    static propTypes = {
        inputListHandler:     PropTypes.func.isRequired,
        inputFieldValue:      PropTypes.string,
        placeholderMessageId: PropTypes.string
    };

    static defaultProps = {
        inputFieldValue:      '',
        placeholderMessageId: 'General_CoreFunctionality_UIText_general.search'
    };

    constructor(props) {
        super(props);

        this.startSearch = this.startSearch.bind(this);
        this.clearInput = this.clearInput.bind(this);
    }

    startSearch(e) {
        this.props.inputListHandler(e.target.value);
    }

    clearInput() {
        this.props.inputListHandler('');
    }

    render() {
        return (
            <div className="filter-search-box">
                <input type="text"
                       onChange={this.startSearch}
                       value={this.props.inputFieldValue}
                       placeholder={this.props.intl.formatMessage(
                           {id: this.props.placeholderMessageId})} />
                <span className={this.props.inputFieldValue ? 'la-CloseRemove' : 'la-Search'} onClick={this.clearInput} />
            </div>
        );
    }


}

export default injectIntl(FilterSearchBox);


// WEBPACK FOOTER //
// ./src/scripts/reusable/SearchBox/FIlterSearchBox.jsx